export default __webpack_public_path__ + "img/18.ce7d9f.png";